@if (connectionService.isConnected()) {
<div class="m-auto" [attr.data-testid]="'login-container'">
  <div
    class="flex flex-col py-8 lg:h-[100vh]"
    [attr.data-testid]="'login-content'"
  >
    <div class="flex-2"></div>
    <div
      class="max-h-full w-full !flex-col items-center justify-center overflow-auto rounded-2xl px-8 py-4 pb-6 shadow-2xl lg:w-[464px]"
      [attr.data-testid]="'login-form-container'"
    >
      <router-outlet></router-outlet>
    </div>
    <div class="flex-[3]"></div>
  </div>
</div>
} @else {
<div
  class="flex h-full w-full items-center justify-center"
  [attr.data-testid]="'loading-container'"
>
  <div [attr.data-testid]="'loading-content'">
    <mat-progress-spinner
      mode="indeterminate"
      class="mb-4"
      [attr.data-testid]="'loading-spinner'"
    >
    </mat-progress-spinner>
    <div
      class="text-center text-sm text-primary-400"
      [attr.data-testid]="'loading-status'"
    >
      {{ connectionService.status() }}
    </div>
  </div>
</div>
}
